import moment from "moment-timezone";

export function useDate() {
  function dateToClient(strDate) {
    if (moment(strDate).isValid()) {
      return moment(strDate).format("DD/MM/YYYY");
    }
    return strDate;
  }

  function datetimeToClient(strDate) {
    // ✅ CORRECCIÓN CRÍTICA: Validar Y parsear con formato explícito
    // Esto evita que moment interprete la fecha como UTC
    const parsed = moment(strDate, 'YYYY-MM-DD HH:mm:ss', true);
    if (parsed.isValid()) {
      // ✅ CORRECCIÓN: Mostrar fecha directamente sin conversión de timezone
      // Las fechas en BD están guardadas como strings "naive" en zona empresa
      // Solo formatear para visualización, sin aplicar conversiones
      // Esto evita que cambien cuando se modifica la zona horaria en Settings
      return parsed.format("DD/MM/YYYY HH:mm");
    }
    // Fallback: intentar parseo sin formato estricto
    const fallback = moment(strDate);
    if (fallback.isValid()) {
      return fallback.format("DD/MM/YYYY HH:mm");
    }
    return strDate;
  }

  function dateToDatabase(strDate) {
    if (moment(strDate, "DD/MM/YYYY").isValid()) {
      return moment(strDate).format("YYYY-MM-DD HH:mm:ss");
    }
    return strDate;
  }

  return {
    dateToClient,
    datetimeToClient,
    dateToDatabase,
  };
}
